import { dynamicLoader } from '~/utils';

export const SquirePopup = dynamicLoader({
  name: 'SquirePopup',
  importFunc: () => import('./squire-popup'),
});